import type { ProgramNewsDeliveryClass } from "@/services/adminProgramNews";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

/** Alerts stand out; digests are ordinary; ignores fade. */
export function classBadgeVariant(
  deliveryClass: ProgramNewsDeliveryClass | null | undefined
): BadgeVariant {
  switch (deliveryClass) {
    case "alert":
      return "default";
    case "digest":
      return "secondary";
    default:
      return "outline";
  }
}
